import base from './base2.repository';
export default {
    getBroadcastMessages: (userId, filters, page = 1) => base.get(`broadcast-messages/${userId}/by-user`, {...filters, page})
}


// WEBPACK FOOTER //
// ./src/repositories/broadcastMessages.repository.js